if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.closeTimers = new WeakMap();
      this.mouseCloseDelay = 1000;
    }
    connectedCallback() {
      this.menuItems = this.querySelectorAll('.menu-item-has-children');
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.menuItems.length) return;

      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

      this.querySelectorAll('.submenu-toggle').forEach((button) => {
        button.addEventListener('click', this.onToggleClick.bind(this));
      });

      this.querySelectorAll('.mega-menu-close').forEach((button) => {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      });

      this.menuItems.forEach((item) => {
        item.addEventListener('mouseenter', this.onMenuItemMouseEnter.bind(this));
        item.addEventListener('mouseleave', this.onMenuItemMouseLeave.bind(this));
        item.addEventListener('focusout', this.onMenuItemFocusOut.bind(this));
      });

      this.addEventListener('keydown', this.onKeyDown.bind(this));
      this.addEventListener('keyup', this.onKeyDown.bind(this));
    }
    onToggleClick(event) {
      event.preventDefault();

      const button = event.currentTarget;
      const menuItem = button.closest('.menu-item-has-children');

      if (!menuItem) return;

      if (menuItem.classList.contains('is-open')) {
        this.closeMenu(menuItem, false);
      } else {
        this.openMenu(menuItem);
      }
    }
    onCloseButtonClick(event) {
      event.preventDefault();

      const menuItem = event.currentTarget.closest('.menu-item-has-children');
      this.closeMenu(menuItem, true);
    }
    onMenuItemMouseEnter(event) {
      const menuItem = event.currentTarget;
      this.clearCloseTimer(menuItem);
      this.openMenu(menuItem, false);
    }
    onMenuItemMouseLeave(event) {
      const menuItem = event.currentTarget;

      this.clearCloseTimer(menuItem);
      this.closeTimers.set(menuItem, window.setTimeout(() => {
        this.closeMenu(menuItem, false);
      }, this.mouseCloseDelay));
    }
    onMenuItemFocusOut(event) {
      const menuItem = event.currentTarget;

      window.setTimeout(() => {
        if (!menuItem.contains(document.activeElement)) {
          this.closeMenu(menuItem, false);
        }
      });
    }
    onKeyDown(event) {
      const isEscape = event.key === 'Escape' || event.key === 'Esc' || event.code === 'Escape';

      if (!isEscape) return;

      const menuItem = event.target.closest('.menu-item-has-children.is-open');
      if (!menuItem || !this.contains(menuItem)) return;

      event.preventDefault();
      event.stopPropagation();
      this.closeMenu(menuItem, true);
    }
    openMenu(menuItem, closeSiblings = true) {
      if (!menuItem) return;

      this.clearCloseTimer(menuItem);

      if (closeSiblings) {
        this.closeSiblingMenus(menuItem);
      }

      menuItem.classList.add('is-open');
      this.setExpanded(menuItem, true);
    }
    closeMenu(menuItem, restoreFocus = false) {
      if (!menuItem) return;

      this.clearCloseTimer(menuItem);
      menuItem.classList.remove('is-open');
      this.setExpanded(menuItem, false);

      menuItem.querySelectorAll('.menu-item-has-children.is-open').forEach((childItem) => {
        childItem.classList.remove('is-open');
        this.setExpanded(childItem, false);
      });

      if (restoreFocus) {
        const button = menuItem.querySelector(':scope > .submenu-toggle');
        if (button) {
          window.requestAnimationFrame(() => {
            button.focus();
          });
        }
      }
    }
    closeSiblingMenus(menuItem) {
      if (!menuItem.parentElement) return;

      Array.from(menuItem.parentElement.children).forEach((sibling) => {
        if (sibling !== menuItem && sibling.classList && sibling.classList.contains('is-open')) {
          this.closeMenu(sibling, false);
        }
      });
    }
    clearCloseTimer(menuItem) {
      const timer = this.closeTimers.get(menuItem);

      if (timer) {
        window.clearTimeout(timer);
        this.closeTimers.delete(menuItem);
      }
    }
    setExpanded(menuItem, expanded) {
      const button = menuItem.querySelector(':scope > .submenu-toggle');

      if (button) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
